import { Edit, Delete, ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { TableRow, TableCell, Checkbox, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { ServiceCheckListItemDialog } from "./ServiceCheckListItemDialog";
import { IServiceCheckListItem } from "../../interfaces/IServiceCheckListItem";

interface IProps {
    checkListItem: IServiceCheckListItem;
    index: number;
    checkListItems: IServiceCheckListItem[];
    setCheckListItems: Function;
}

export const ServiceCheckListItem: React.FC<IProps> = ({ index, checkListItem, checkListItems, setCheckListItems }) => {
    const [isEditCheckListItemOpen, setIsEditCheckListItemOpen] = useState<boolean>(false);

    const getUp = () => {
        const itemAboveTheCheckListItem = checkListItems.find((x) => x.position === checkListItem.position - 1);

        if (itemAboveTheCheckListItem) {
            itemAboveTheCheckListItem.position = itemAboveTheCheckListItem.position + 1;
            checkListItem.position = checkListItem.position - 1;

            setCheckListItems([
                ...checkListItems.map((x) =>
                    x.id === itemAboveTheCheckListItem.id
                        ? itemAboveTheCheckListItem
                        : x.id === checkListItem.id
                          ? checkListItem
                          : x,
                ),
            ]);
        }
    };

    const getDown = () => {
        const itemUnderTheCheckListItem = checkListItems.find((x) => x.position === checkListItem.position + 1);

        if (itemUnderTheCheckListItem) {
            itemUnderTheCheckListItem.position = itemUnderTheCheckListItem.position - 1;
            checkListItem.position = checkListItem.position + 1;

            setCheckListItems([
                ...checkListItems.map((x) =>
                    x.id === itemUnderTheCheckListItem.id
                        ? itemUnderTheCheckListItem
                        : x.id === checkListItem.id
                          ? checkListItem
                          : x,
                ),
            ]);
        }
    };

    return (
        <>
            {isEditCheckListItemOpen && (
                <ServiceCheckListItemDialog
                    isCheckListItemDialogOpen={isEditCheckListItemOpen}
                    setIsCheckListItemDialogOpen={setIsEditCheckListItemOpen}
                    checkListItem={checkListItem}
                    checkListItems={checkListItems}
                    setCheckListItems={setCheckListItems}
                ></ServiceCheckListItemDialog>
            )}

            <TableRow key={index}>
                <TableCell>{checkListItem.title}</TableCell>

                <TableCell>{checkListItem.description}</TableCell>

                <TableCell>
                    <Tooltip
                        title={
                            checkListItem.position === checkListItems.length
                                ? "nicht möglich!"
                                : "Checklisteintrag nach unten verschieben."
                        }
                        disableInteractive
                        disableHoverListener={false}
                    >
                        <span style={{ float: "right" }}>
                            <IconButton
                                disabled={checkListItem.position === checkListItems.length}
                                size="small"
                                onClick={getDown}
                            >
                                <ArrowDownward />
                            </IconButton>
                        </span>
                    </Tooltip>

                    <Tooltip
                        title={
                            checkListItem.position === 1 ? "nicht möglich!" : "Checklisteintrag nach oben verschieben."
                        }
                        disableInteractive
                        disableHoverListener={false}
                    >
                        <span style={{ float: "right" }}>
                            <IconButton disabled={checkListItem.position === 1} size="small" onClick={getUp}>
                                <ArrowUpward />
                            </IconButton>
                        </span>
                    </Tooltip>
                </TableCell>

                <TableCell>
                    <Checkbox checked={checkListItem.isPhotoRequired} disabled />
                </TableCell>

                <TableCell>
                    <IconButton
                        size="small"
                        onClick={() => {
                            setIsEditCheckListItemOpen(true);
                        }}
                    >
                        <Edit />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={() => {
                            const newList = checkListItems.filter((item) => item.id !== checkListItem.id);

                            const updatedListWithNewPositions = newList.map((item, index) => ({
                                ...item,
                                position: index + 1,
                            }));

                            setCheckListItems(updatedListWithNewPositions);
                        }}
                    >
                        <Delete />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
};
